import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ha-progress-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("メールアドレス"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("入力")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("確認コード"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("入力")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("会員情報"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("入力・確認")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "登録完了", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: _normalizeClass(["ha-progress-listitem", {'current': _ctx.signupProgress === 'Signup'}])
    }, _hoisted_3, 2),
    _createElementVNode("li", {
      class: _normalizeClass(["ha-progress-listitem", {'current': _ctx.signupProgress === 'SignupCode'}])
    }, _hoisted_5, 2),
    _createElementVNode("li", {
      class: _normalizeClass(["ha-progress-listitem", {'current': _ctx.signupProgress === 'SignupProfile' || _ctx.signupProgress === 'SignupConfirm'}])
    }, _hoisted_7, 2),
    _createElementVNode("li", {
      class: _normalizeClass(["ha-progress-listitem", {'current': _ctx.signupProgress === 'SignupComplete'}])
    }, _hoisted_9, 2)
  ]))
}